import type { ErrorRegistryShape } from '../common/common.error';

export const PORTFOLIO_ERROR = {
  NOT_FOUND_PORTFOLIO: { status: 404, message: 'Portfolio not found' },
  /** 로그인 아이디는 D3 회원 · LP 계정 · 포트폴리오 계정을 통틀어 하나여야 한다(로그인이 d3 → lp → pf 순서로 찾는다) */
  CONFLICT_PORTFOLIO_USERNAME_DUPLICATE: { status: 409, message: 'Username already in use' },
  /**
   * 포트폴리오 회원이 D3 전용 필드(담당자 · 순서 · 그래프 코멘트 · 서류 요청 · 기본 통화)를 바꾸려 함.
   * 조용히 버리지 않고 거절한다. data: { fields: string[] } — 보낸 D3 전용 필드 이름
   */
  FORBIDDEN_PORTFOLIO_D3_ONLY_FIELDS: {
    status: 403,
    message: 'Only D3 members can change these fields',
  },
} as const satisfies ErrorRegistryShape;
